import React, { useState, useEffect } from "react";
import { message } from "antd";
import { useSelector } from "react-redux";

import NotificationItem from "./NotificationItem";
import EmptyState from "../common/EmptyState";
import { fetchDashboardAlertsAPI } from "../../services/dashboard-service";

const AppNotification = () => {
  const authUser = useSelector((state) => state.auth.authUser);
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  const mipId = authUser?.site?.mipId ?? -1;

  useEffect(() => {
    async function fetchNotifications() {
      try {
        const res = await fetchDashboardAlertsAPI(mipId);

        if (res.success) {
          setNotifications(res.data || []);
        } else {
          throw new Error("Error fetching Notifications");
        }
      } catch (error) {
        message.error(error.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    }

    if (mipId !== -1) {
      fetchNotifications();
    }
  }, [mipId]);

  return (
    <div className="notifications-popover">
      <div className="gx-popover-header">
        <h3 className="gx-mb-0">Notifications</h3>
      </div>

      <div className="gx-popover-scroll">
        {loading ? (
          <div className="gx-text-center gx-py-3">Loading...</div>
        ) : notifications.length > 0 ? (
            <NotificationItem notifications={notifications} />
        ) : (
          <EmptyState
            icon="info-circle"
            message="No notifications right now."
          />
        )}
      </div>
    </div>
  );
};

export default AppNotification;